import { render, staticRenderFns } from "./TradeStatus.vue?vue&type=template&id=38b783e6&scoped=true"
import script from "./TradeStatus.vue?vue&type=script&lang=js"
export * from "./TradeStatus.vue?vue&type=script&lang=js"
import style0 from "./TradeStatus.vue?vue&type=style&index=0&id=38b783e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b783e6",
  null
  
)

export default component.exports